
import { Injectable, EventEmitter } from '@angular/core';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { DocumentosObservableService } from './DocumentosObservable';
import { DocumentsNeedNotifications } from './DocumentsNeededNotification';
import ArrayHelpers from '../ArrayHelper';
import { PersonTypeString } from '../Models/const.personType';
import { isNotNullOrUndefinedOrEmpty, isNullOrUndefinedOrEmpty } from '../objectUtils';
import { DropdownsValues } from '../Dropdowns/const.dropdowns';
import DateHelpers from '../DateHelpers';
interface BeneficiaryNotification {
  noticationId: number,
  beneficiaryName: string,
  nif: number
}

@Injectable({
  providedIn: "root"
})
export class PrestacoesMorteValueObservableService {


  private deceasedRelationshipValues = DropdownsValues.dropdownDeceasedRelationship;
  private personTypologyValues = DropdownsValues.dropDownPersonType;
  private scholarSituationValues = DropdownsValues.dropListScholarSituationDeathDate;
  private dropdowsDocumentsValues = DropdownsValues.dropListDocuments;
  constructor(private documentsObservableService: DocumentosObservableService) {
    this.documentsObservableService.toDeleteAll.subscribe(docs => {
      this.legalRepresentativeNotificationId = null;
      this.certidaoNascimentoFalecidoNotificationId = null;
      this.provaEfetividadeNotificationId = null;
      this.faturaOuRecidoDespesaFuneralNotificationId = [];
      this.certidaoNascimentoRequerenteNotificationId = [];
      this.atestadoJuntaFreguesiaNotificationId = [];
      this.declCompHonraNotificationId = [];
      this.declProvaEscolarNotificationId = [];
      this.docComprovativoSSNotificationId = [];
      this.sentencaNotificationId = [];
      this.declaracaoIRSNotificationId = [];
      this.declaracaoPensaoAlimentosNotificationId = [];
      this.docPrestacoesFamiliaresNotificationId = [];
      this.docPSINotificationId = [];
      this.certidaoIsensaoIRSNotificationId = [];
      this.comprovativoIBANNotificationId = [];
      this.requerendoNotificationId = [];
      this.legalRepresentativeBeneficiaryNotificationId = [];
      this.legalRepresentativeCertidaoBeneficiaryNotificationId = [];
    })
  }

  public assignateDropdowns(res: models.WorkflowDropdownsVM) {
    const dropdownDocs = res.options.filter(el => el.dropdown == "dropListDocuments");
    
    DocumentsNeedNotifications.PrestacoesMorte.RepresentacaoLegal.documentTipologyDescription =
      dropdownDocs.find(el => el.value == this.dropdowsDocumentsValues.ComprovativoRepresLegal).filter2;

    DocumentsNeedNotifications.PrestacoesMorte.CertidaoNascimentoFalecido.documentTipologyDescription =
      dropdownDocs.find(el => el.value == this.dropdowsDocumentsValues.CertidaoNascFalecido).filter2;

    DocumentsNeedNotifications.PrestacoesMorte.ProvaEfectividade.documentTipologyDescription =
      dropdownDocs.find(el => el.value == this.dropdowsDocumentsValues.ProvaEfetividade).filter2;

    DocumentsNeedNotifications.PrestacoesMorte.FaturaOuRecibo.documentTipologyDescription =
      dropdownDocs.find(el => el.value == this.dropdowsDocumentsValues.FaturaOuRecibo).filter2;


    DocumentsNeedNotifications.PrestacoesMorte.CertidaoNascimentoRequerente.documentTipologyDescription =
      dropdownDocs.find(el => el.value == this.dropdowsDocumentsValues.CertidaoNascRequerente).filter2;

    DocumentsNeedNotifications.PrestacoesMorte.AtestadoJuntaFreguesia.documentTipologyDescription =
      dropdownDocs.find(el => el.value == this.dropdowsDocumentsValues.AtestadoJuntaFreguesia).filter2;

    DocumentsNeedNotifications.PrestacoesMorte.DeclaracaoCompromissoHonra.documentTipologyDescription =
      dropdownDocs.find(el => el.value == this.dropdowsDocumentsValues.DeclarComprHonra).filter2;

    DocumentsNeedNotifications.PrestacoesMorte.ProvaEscolar.documentTipologyDescription =
      dropdownDocs.find(el => el.value == this.dropdowsDocumentsValues.ProvaEscolar).filter2;

    DocumentsNeedNotifications.PrestacoesMorte.DocComprovSegurancaSocial.documentTipologyDescription =
      dropdownDocs.find(el => el.value == this.dropdowsDocumentsValues.DocComprovativoSegSocial).filter2;

    DocumentsNeedNotifications.PrestacoesMorte.Sentenca.documentTipologyDescription =
      dropdownDocs.find(el => el.value == this.dropdowsDocumentsValues.SentencaHabilJudicial).filter2;

    DocumentsNeedNotifications.PrestacoesMorte.DeclaracaoIRS.documentTipologyDescription =
      dropdownDocs.find(el => el.value == this.dropdowsDocumentsValues.DeclarIRS).filter2;

    DocumentsNeedNotifications.PrestacoesMorte.DeclaracaoPensaoAlimentos.documentTipologyDescription =
      dropdownDocs.find(el => el.value == this.dropdowsDocumentsValues.DeclarPensaoAlimentos).filter2;

    DocumentsNeedNotifications.PrestacoesMorte.DocPrestacoesFamiliares.documentTipologyDescription =
      dropdownDocs.find(el => el.value == this.dropdowsDocumentsValues.DocPrestacoesFamiliares).filter2;

    DocumentsNeedNotifications.PrestacoesMorte.DOCPSI.documentTipologyDescription =
      dropdownDocs.find(el => el.value == this.dropdowsDocumentsValues.DeclarPrestSocialInclusao).filter2;

    DocumentsNeedNotifications.PrestacoesMorte.CertidaoIsensaoIRS.documentTipologyDescription =
      dropdownDocs.find(el => el.value == this.dropdowsDocumentsValues.CertidaoIsencaoIRS).filter2;

    DocumentsNeedNotifications.PrestacoesMorte.ComprovativoIBAN.documentTipologyDescription =
      dropdownDocs.find(el => el.value == this.dropdowsDocumentsValues.ComprovativoIBAN).filter2;

    DocumentsNeedNotifications.PrestacoesMorte.RequerendoEmNomeHabilitando.documentTipologyDescription =
      dropdownDocs.find(el => el.value == this.dropdowsDocumentsValues.DeclRequerHabilitando).filter2;

  }


  //#region legalRepresentative
  private legalRepresentativeNotification: models.DocumentosObservableVM = DocumentsNeedNotifications.PrestacoesMorte.RepresentacaoLegal;
  private legalRepresentativeNotificationId: number;

  public legalRepresentativeValidation(isLegalRepresentative: boolean): boolean {
    let result = isNotNullOrUndefinedOrEmpty(isLegalRepresentative) && isLegalRepresentative?.toString()=='true';
    return result;
  }

  public changeLegalRepresentativeNotification(ownerName: string, ownerNif: number, value: boolean) {
    const legalRepresentativeNotification = { ...this.legalRepresentativeNotification };
    legalRepresentativeNotification.ownerCode = PersonTypeString.Sender;
    legalRepresentativeNotification.ownerName = ownerName;
    legalRepresentativeNotification.ownerNif = ownerNif;
    legalRepresentativeNotification.ownerParentCode = null;
    legalRepresentativeNotification.ownerTitle = PersonTypeString.Sender;
    legalRepresentativeNotification.order = null;
    if (value && !this.documentsObservableService.hasDocWithSameNIF(legalRepresentativeNotification)) {
      this.legalRepresentativeNotificationId =
        this.documentsObservableService.pushNotification(legalRepresentativeNotification);
    } else if (!value) {
      if (this.legalRepresentativeNotificationId !== null && this.legalRepresentativeNotificationId !== undefined) {
        this.documentsObservableService.popNotificationById(this.legalRepresentativeNotificationId);
      }
      this.legalRepresentativeNotificationId = null;
    }
  }
  //#endregion legalRepresentative

  //#region legalRepresentative beneficiary
  private legalRepresentativeBeneficiaryNotification: models.DocumentosObservableVM = DocumentsNeedNotifications.PrestacoesMorte.RepresentacaoLegalBeneficiary;
  private legalRepresentativeBeneficiaryNotificationId: BeneficiaryNotification[] = [];

  public legalRepresentativeBeneficiaryValidation(hasLegalRepresentation: boolean, legalRepresentativeIsNotSender: boolean): boolean {
    let result = isNotNullOrUndefinedOrEmpty(hasLegalRepresentation) &&
      hasLegalRepresentation?.toString() == 'true' &&
      legalRepresentativeIsNotSender?.toString() == 'true';
    return result;
  }

  public changeLegalRepresentativeBeneficiaryNotification(value: boolean, ownerName: string, ownerNif: number, beneficiaryID:number) {
    const notification: models.DocumentosObservableVM = {
      ...this.legalRepresentativeBeneficiaryNotification,
      beneficiaryID: beneficiaryID,
      ownerCode: PersonTypeString.Beneficiary,
      ownerName: ownerName,
      ownerNif: ownerNif,
      ownerTitle: PersonTypeString.Beneficiary,
      ownerParentCode: null,
      order: null
    };

    this.processBeneficiaryNotification(
      value, notification, this.legalRepresentativeBeneficiaryNotificationId
    );
  }
  //#endregion legalRepresentative beneficiary

  //#region legalRepresentative certidao beneficiary
  private legalRepresentativeCertidaoBeneficiaryNotification: models.DocumentosObservableVM = DocumentsNeedNotifications.PrestacoesMorte.RepresentacaoLegalCertidaoBeneficiary;
  private legalRepresentativeCertidaoBeneficiaryNotificationId: BeneficiaryNotification[] = [];

  public legalRepresentativeCertidaoBeneficiaryValidation(hasLegalRepresentation: boolean, legalRepresentativeIsNotSender: boolean): boolean {
    let result = isNotNullOrUndefinedOrEmpty(hasLegalRepresentation) &&
      hasLegalRepresentation?.toString() == 'true' &&
      legalRepresentativeIsNotSender?.toString() == 'true';
    return result;
  }

  public changeLegalRepresentativeCertidaoBeneficiaryNotification(value: boolean, ownerName: string, ownerNif: number, beneficiaryID: number) {
    const notification: models.DocumentosObservableVM = {
      ...this.legalRepresentativeCertidaoBeneficiaryNotification,
      beneficiaryID: beneficiaryID,
      ownerCode: PersonTypeString.Beneficiary,
      ownerName: ownerName,
      ownerNif: ownerNif,
      ownerTitle: PersonTypeString.Beneficiary,
      ownerParentCode: null,
      order: null
    };

    this.processBeneficiaryNotification(
      value, notification, this.legalRepresentativeCertidaoBeneficiaryNotificationId
    );
  }
  //#endregion legalRepresentative certidao beneficiary

  //#region certidaoNascimentoFalecido
  private certidaoNascimentoFalecidoNotification: models.DocumentosObservableVM = DocumentsNeedNotifications.PrestacoesMorte.CertidaoNascimentoFalecido;
  private certidaoNascimentoFalecidoNotificationId: number;

  public certidaoNascimentoFalecidoValidation(): boolean {
    let result = true;
    return result;
  }

  public changeCertidaoNascimentoFalecidoNotification(ownerName: string, ownerNif: number, value: boolean) {
    const notification = { ...this.certidaoNascimentoFalecidoNotification };
    notification.ownerCode = PersonTypeString.Deceased;
    notification.ownerName = ownerName;
    notification.ownerNif = ownerNif;
    notification.ownerParentCode = null;
    notification.ownerTitle = PersonTypeString.Deceased;
    notification.order = null;
    if (value && !this.documentsObservableService.hasDocWithSameNIF(notification)) {
      this.certidaoNascimentoFalecidoNotificationId =
        this.documentsObservableService.pushNotification(notification);
    } else if (!value) {
      if (this.certidaoNascimentoFalecidoNotificationId !== null && this.certidaoNascimentoFalecidoNotificationId !== undefined) {
        this.documentsObservableService.popNotificationById(this.certidaoNascimentoFalecidoNotificationId);
      }
      this.certidaoNascimentoFalecidoNotificationId = null;
    }
  }
  //#endregion certidaoNascimentoFalecido



  //#region provaEfetividade
  private provaEfetividadeNotification: models.DocumentosObservableVM = DocumentsNeedNotifications.PrestacoesMorte.ProvaEfectividade;
  private provaEfetividadeNotificationId: number;

  //-Estava a receber uma pensão de aposentação/reforma pela CGA à data do óbito?: "Não"
  //+Pediu pensao sobrevivencia
  public provaEfetividadeValidation(hadPensionCGABeforeDeath: boolean, survivalPensionBenefit: boolean): boolean {
    let result = hadPensionCGABeforeDeath?.toString() == "false" && survivalPensionBenefit?.toString() == "true";
    return result;
  }

  public changeProvaEfetividadeNotification(ownerName: string, ownerNif: number, value: boolean) {
    const notification = { ...this.provaEfetividadeNotification };
    notification.ownerCode = PersonTypeString.Deceased;
    notification.ownerName = ownerName;
    notification.ownerNif = ownerNif;
    notification.ownerParentCode = null;
    notification.ownerTitle = PersonTypeString.Deceased;
    notification.order = null;
    if (value && !this.documentsObservableService.hasDocWithSameNIF(notification)) {
      this.provaEfetividadeNotificationId =
        this.documentsObservableService.pushNotification(notification);
    } else if (!value) {
      if (this.provaEfetividadeNotificationId !== null && this.provaEfetividadeNotificationId !== undefined) {
        this.documentsObservableService.popNotificationById(this.provaEfetividadeNotificationId);
      }
      this.provaEfetividadeNotificationId = null;
    }
  }
  //#endregion provaEfetividade



  //#region faturaOuRecidoDespesaFuneral
  private faturaOuRecidoDespesaFuneralNotification: models.DocumentosObservableVM = DocumentsNeedNotifications.PrestacoesMorte.FaturaOuRecibo;
  private faturaOuRecidoDespesaFuneralNotificationId: BeneficiaryNotification[] = [];

  public faturaOuRecidoDespesaFuneralValidation(reimbursementFuneralBenefit: boolean): boolean {
    let result = reimbursementFuneralBenefit?.toString() == 'true';;
    return result;
  }

  public changeFaturaOuRecidoDespesaFuneralNotification(value: boolean, ownerName: string, ownerNif: number, beneficiaryID: number) {
    const notification: models.DocumentosObservableVM = {
      ...this.faturaOuRecidoDespesaFuneralNotification,
      beneficiaryID: beneficiaryID,
      ownerCode: PersonTypeString.Beneficiary,
      ownerName: ownerName,
      ownerNif: ownerNif,
      ownerTitle: PersonTypeString.Beneficiary,
      ownerParentCode: null,
      order: null
    };

    this.processBeneficiaryNotification(
      value, notification, this.faturaOuRecidoDespesaFuneralNotificationId
    );
  }
  //#endregion faturaOuRecidoDespesaFuneral


  //#region certidaoNascimentoRequerente
  private certidaoNascimentoRequerenteNotification: models.DocumentosObservableVM = DocumentsNeedNotifications.PrestacoesMorte.CertidaoNascimentoRequerente;
  private certidaoNascimentoRequerenteNotificationId: BeneficiaryNotification[] = [];

  public certidaoNascimentoRequerenteValidation(survivalPensionBenefit: boolean, funeralAllowanceBenefit: boolean, deceasedRelationship:string): boolean {
    let result = (survivalPensionBenefit?.toString() == 'true' ||
      funeralAllowanceBenefit?.toString() == 'true') &&
      isNotNullOrUndefinedOrEmpty(deceasedRelationship) &&
      (deceasedRelationship != this.deceasedRelationshipValues.Conjugue);;
    return result;
  }

  public changeCertidaoNascimentoRequerenteNotification(value: boolean, ownerName: string, ownerNif: number, beneficiaryID: number) {
    const notification: models.DocumentosObservableVM = {
      ...this.certidaoNascimentoRequerenteNotification,
      beneficiaryID: beneficiaryID,
      ownerCode: PersonTypeString.Beneficiary,
      ownerName: ownerName,
      ownerNif: ownerNif,
      ownerTitle: PersonTypeString.Beneficiary,
      ownerParentCode: null,
      order: null
    };

    this.processBeneficiaryNotification(
      value, notification, this.certidaoNascimentoRequerenteNotificationId
    );

  }
  //#endregion certidaoNascimentoRequerente


  //#region atestadoJuntaFreguesia
  private atestadoJuntaFreguesiaNotification: models.DocumentosObservableVM = DocumentsNeedNotifications.PrestacoesMorte.AtestadoJuntaFreguesia;
  private atestadoJuntaFreguesiaNotificationId: BeneficiaryNotification[] = [];

  public atestadoJuntaFreguesiaValidation(survivalPensionBenefit: boolean, funeralAllowanceBenefit: boolean, deceasedRelationship:string): boolean {
    let result = (survivalPensionBenefit?.toString() == 'true' || funeralAllowanceBenefit?.toString() == 'true')
      && deceasedRelationship == this.deceasedRelationshipValues.UniaoDeFacto;
    return result;
  }

  public changeAtestadoJuntaFreguesiaNotification(value: boolean, ownerName: string, ownerNif: number, beneficiaryID: number) {
    const notification: models.DocumentosObservableVM = {
      ...this.atestadoJuntaFreguesiaNotification,
      beneficiaryID: beneficiaryID,
      ownerCode: PersonTypeString.Beneficiary,
      ownerName: ownerName,
      ownerNif: ownerNif,
      ownerTitle: PersonTypeString.Beneficiary,
      ownerParentCode: null,
      order: null
    };
    this.processBeneficiaryNotification(
      value, notification, this.atestadoJuntaFreguesiaNotificationId
    );
  }
  //#endregion atestadoJuntaFreguesia


  //#region declCompHonra
  private declCompHonraNotification: models.DocumentosObservableVM = DocumentsNeedNotifications.PrestacoesMorte.DeclaracaoCompromissoHonra;
  private declCompHonraNotificationId: BeneficiaryNotification[] = [];

  public declCompHonraValidation(survivalPensionBenefit: boolean, funeralAllowanceBenefit: boolean, deceasedRelationship: string): boolean {
    let result = (survivalPensionBenefit?.toString() == 'true' || funeralAllowanceBenefit?.toString() == 'true')
      && deceasedRelationship == this.deceasedRelationshipValues.UniaoDeFacto;
    return result;
  }

  public changeDeclCompHonraNotification(value: boolean, ownerName: string, ownerNif: number, beneficiaryID: number) {
    const notification: models.DocumentosObservableVM = {
      ...this.declCompHonraNotification,
      beneficiaryID: beneficiaryID,
      ownerCode: PersonTypeString.Beneficiary,
      ownerName: ownerName,
      ownerNif: ownerNif,
      ownerTitle: PersonTypeString.Beneficiary,
      ownerParentCode: null,
      order: null
    };
    this.processBeneficiaryNotification(
      value, notification, this.declCompHonraNotificationId
    );

  }
  //#endregion declCompHonra


  //#region declProvaEscolar
  private declProvaEscolarNotification: models.DocumentosObservableVM = DocumentsNeedNotifications.PrestacoesMorte.ProvaEscolar;
  private declProvaEscolarNotificationId: BeneficiaryNotification[] = [];

  public declProvaEscolarValidation(survivalPensionBenefit: boolean, funeralAllowanceBenefit: boolean
    , deceasedRelationship: string, dateOfBirth: Date
    , hasChargeDeceased: boolean, dataFalecimento: Date, registrationYear: number, hasIncapacity: boolean): boolean {
    const filhosResult = ((survivalPensionBenefit?.toString() == 'true' || funeralAllowanceBenefit?.toString() == 'true')
      && deceasedRelationship == this.deceasedRelationshipValues.Filhos &&
      DateHelpers.isAdult(dateOfBirth) && hasIncapacity?.toString() != 'true');

    const netosResult = deceasedRelationship == this.deceasedRelationshipValues.Netos && DateHelpers.isAdult(dateOfBirth) &&
      isNotNullOrUndefinedOrEmpty(hasChargeDeceased) && hasChargeDeceased.toString() == 'true' &&
      hasIncapacity?.toString() == 'false';

    const anoResult = isNotNullOrUndefinedOrEmpty(dataFalecimento) &&
      registrationYear == dataFalecimento.getFullYear(); //&& hasIncapacity?.toString() == 'false';

    let result = filhosResult || netosResult;
    if (deceasedRelationship != this.deceasedRelationshipValues.Netos && deceasedRelationship != this.deceasedRelationshipValues.Filhos) {
      result = result || anoResult;
    }
    
    return result;
  }

  public changeProvaEscolarNotification(value: boolean, ownerName: string, ownerNif: number, beneficiaryID: number) {
    const notification: models.DocumentosObservableVM = {
      ...this.declProvaEscolarNotification,
      beneficiaryID: beneficiaryID,
      ownerCode: PersonTypeString.Beneficiary,
      ownerName: ownerName,
      ownerNif: ownerNif,
      ownerTitle: PersonTypeString.Beneficiary,
      ownerParentCode: null,
      order: null
    };
    this.processBeneficiaryNotification(
      value, notification, this.declProvaEscolarNotificationId
    );

  }
  //#endregion declProvaEscolar


  //#region docComprovativoSS
  private docComprovativoSSNotification: models.DocumentosObservableVM = DocumentsNeedNotifications.PrestacoesMorte.DocComprovSegurancaSocial;
  private docComprovativoSSNotificationId: BeneficiaryNotification[] = [];

  public docComprovativoSSValidation(survivalPensionBenefit: boolean, funeralAllowanceBenefit: boolean
    , deceasedRelationship: string, dateOfBirth: Date
    , hasChargeDeceased: boolean, hasIncapacity: boolean, activeProfessionalSituation: boolean): boolean {
    let result = (survivalPensionBenefit?.toString() == 'true' || funeralAllowanceBenefit?.toString() == 'true') &&
      (deceasedRelationship == this.deceasedRelationshipValues.Filhos && DateHelpers.isAdult(dateOfBirth)) ||
      (deceasedRelationship == this.deceasedRelationshipValues.Netos && DateHelpers.isAdult(dateOfBirth) && hasChargeDeceased?.toString() == 'true') ||
      hasIncapacity?.toString() == 'true' || activeProfessionalSituation?.toString() == 'true';
    return result;
  }

  public changedocComprovativoSSNotification(value: boolean, ownerName: string, ownerNif: number, beneficiaryID: number) {
    const notification: models.DocumentosObservableVM = {
      ...this.docComprovativoSSNotification,
      beneficiaryID: beneficiaryID,
      ownerCode: PersonTypeString.Beneficiary,
      ownerName: ownerName,
      ownerNif: ownerNif,
      ownerTitle: PersonTypeString.Beneficiary,
      ownerParentCode: null,
      order: null
    };
    this.processBeneficiaryNotification(
      value, notification, this.docComprovativoSSNotificationId
    );
  }
  //#endregion docComprovativoSS


  //#region sentenca
  private sentencaNotification: models.DocumentosObservableVM = DocumentsNeedNotifications.PrestacoesMorte.Sentenca;
  private sentencaNotificationId: BeneficiaryNotification[] = [];

  public sentencaValidation(survivalPensionBenefit: boolean, funeralAllowanceBenefit: boolean
    , deceasedRelationship: string, dateOfBirth: Date
    , hasIncapacity: boolean, hasJudicialInterdiction: boolean): boolean {

    let result = //Subsídio por morte/Pensão de sobrevivência + Filho maior incapaz
      ((survivalPensionBenefit?.toString() == 'true' || funeralAllowanceBenefit?.toString() == 'true') &&
        deceasedRelationship == this.deceasedRelationshipValues.Filhos && DateHelpers.isAdult(dateOfBirth) && hasIncapacity?.toString() == 'true' && hasJudicialInterdiction?.toString() == 'true') ||
      // Pensão de sobrevivência + Ex-cônjuge
      (survivalPensionBenefit?.toString() == 'true' && deceasedRelationship == this.deceasedRelationshipValues.ExConjugue) ||
      // Interdição judicial
        hasJudicialInterdiction?.toString() == 'true';
    return result;
  }

  public changeSentencaNotification(value: boolean, ownerName: string, ownerNif: number, beneficiaryID: number) {
    const notification: models.DocumentosObservableVM = {
      ...this.sentencaNotification,
      beneficiaryID: beneficiaryID,
      ownerCode: PersonTypeString.Beneficiary,
      ownerName: ownerName,
      ownerNif: ownerNif,
      ownerTitle: PersonTypeString.Beneficiary,
      ownerParentCode: null,
      order: null
    };
    this.processBeneficiaryNotification(
      value, notification, this.sentencaNotificationId
    );

  }
  //#endregion sentenca


  //#region declaracaoIRS
  private declaracaoIRSNotification: models.DocumentosObservableVM = DocumentsNeedNotifications.PrestacoesMorte.DeclaracaoIRS;
  private declaracaoIRSNotificationId: BeneficiaryNotification[] = [];

  public declaracaoIRSValidation(survivalPensionBenefit: boolean, funeralAllowanceBenefit: boolean, deceasedRelationship: string): boolean {
    //Subsídio por morte / Pensão de sobrevivência + Pais
    let result = (survivalPensionBenefit?.toString() == 'true' || funeralAllowanceBenefit?.toString() == 'true') &&
      deceasedRelationship == this.deceasedRelationshipValues.Pais;
    return result;
  }

  public changeDeclaracaoIRSNotification(value: boolean, ownerName: string, ownerNif: number, beneficiaryID: number) {
    const notification: models.DocumentosObservableVM = {
      ...this.declaracaoIRSNotification,
      beneficiaryID: beneficiaryID,
      ownerCode: PersonTypeString.Beneficiary,
      ownerName: ownerName,
      ownerNif: ownerNif,
      ownerTitle: PersonTypeString.Beneficiary,
      ownerParentCode: null,
      order: null
    };
    this.processBeneficiaryNotification(
      value, notification, this.declaracaoIRSNotificationId
    );

  }
  //#endregion declaracaoIRS


  //#region declaracaoPensaoAlimentos
  private declaracaoPensaoAlimentosNotification: models.DocumentosObservableVM = DocumentsNeedNotifications.PrestacoesMorte.DeclaracaoPensaoAlimentos;
  private declaracaoPensaoAlimentosNotificationId: BeneficiaryNotification[] = [];

  public declaracaoPensaoAlimentosValidation(hasCourtAlimony: boolean, survivalPensionBenefit: boolean, deceasedRelationship:string): boolean {
    //PensaoAlimentos ou Pensão de sobrevivência + Ex-cônjuge
    let result = hasCourtAlimony?.toString() == 'true' ||
       (survivalPensionBenefit?.toString() == 'true' && deceasedRelationship == this.deceasedRelationshipValues.ExConjugue);
    return result;
  }

  public changeDeclaracaoPensaoAlimentosNotification(value: boolean, ownerName: string, ownerNif: number, beneficiaryID: number) {
    const notification: models.DocumentosObservableVM = {
      ...this.declaracaoPensaoAlimentosNotification,
      beneficiaryID: beneficiaryID,
      ownerCode: PersonTypeString.Beneficiary,
      ownerName: ownerName,
      ownerNif: ownerNif,
      ownerTitle: PersonTypeString.Beneficiary,
      ownerParentCode: null,
      order: null
    };
    this.processBeneficiaryNotification(
      value, notification, this.declaracaoPensaoAlimentosNotificationId
    );
  }
  //#endregion declaracaoPensaoAlimentos


  //#region docPrestacoesFamiliares
  private docPrestacoesFamiliaresNotification: models.DocumentosObservableVM = DocumentsNeedNotifications.PrestacoesMorte.DocPrestacoesFamiliares;
  private docPrestacoesFamiliaresNotificationId: BeneficiaryNotification[] = [];

  public docPrestacoesFamiliaresValidation(deceasedRelationship: string, dateOfBirth: Date, hasIncapacity: boolean, survivalPensionBenefit: boolean, hasChargeDeceased: boolean): boolean {
    // Filho maior incapaz 
    let result = (deceasedRelationship == this.deceasedRelationshipValues.Filhos && DateHelpers.isAdult(dateOfBirth)
      && hasIncapacity?.toString() == 'true');
      // ou Netos menores + Sim
    result = result || (survivalPensionBenefit?.toString() == 'true' && deceasedRelationship == this.deceasedRelationshipValues.Netos &&
      !DateHelpers.isAdult(dateOfBirth) && hasChargeDeceased?.toString() == 'true')

    return result;
  }

  public changeDocPrestacoesFamiliaresNotification(value: boolean, ownerName: string, ownerNif: number, beneficiaryID: number) {
    const notification: models.DocumentosObservableVM = {
      ...this.docPrestacoesFamiliaresNotification,
      beneficiaryID: beneficiaryID,
      ownerCode: PersonTypeString.Beneficiary,
      ownerName: ownerName,
      ownerNif: ownerNif,
      ownerTitle: PersonTypeString.Beneficiary,
      ownerParentCode: null,
      order: null
    };
    this.processBeneficiaryNotification(
      value, notification, this.docPrestacoesFamiliaresNotificationId
    );
  }
  //#endregion docPrestacoesFamiliares


  //#region docPSI
  private docPSINotification: models.DocumentosObservableVM = DocumentsNeedNotifications.PrestacoesMorte.DOCPSI;
  private docPSINotificationId: BeneficiaryNotification[] = [];

  public docPSIValidation(hasSocialPension: boolean): boolean {
    let result = hasSocialPension?.toString()=='true';
    return result;
  }

  public changeDocPSINotificationNotification(value: boolean, ownerName: string, ownerNif: number, beneficiaryID: number) {
    const notification: models.DocumentosObservableVM = {
      ...this.docPSINotification,
      beneficiaryID: beneficiaryID,
      ownerCode: PersonTypeString.Beneficiary,
      ownerName: ownerName,
      ownerNif: ownerNif,
      ownerTitle: PersonTypeString.Beneficiary,
      ownerParentCode: null,
      order: null
    };
    this.processBeneficiaryNotification(
      value, notification, this.docPSINotificationId
    );
  }
  //#endregion docPSI


  //#region certidaoIsensaoIRS
  private certidaoIsensaoIRSNotification: models.DocumentosObservableVM = DocumentsNeedNotifications.PrestacoesMorte.CertidaoIsensaoIRS;
  private certidaoIsensaoIRSNotificationId: BeneficiaryNotification[] = [];

  public certidaoIsensaoIRSValidation(hasIRSExemption: boolean): boolean {
    let result = hasIRSExemption?.toString()=='true';
    return result;
  }

  public changeCertidaoIsensaoIRSNotificationNotification(value: boolean, ownerName: string, ownerNif: number, beneficiaryID: number) {
    const notification: models.DocumentosObservableVM = {
      ...this.certidaoIsensaoIRSNotification,
      beneficiaryID: beneficiaryID,
      ownerCode: PersonTypeString.Beneficiary,
      ownerName: ownerName,
      ownerNif: ownerNif,
      ownerTitle: PersonTypeString.Beneficiary,
      ownerParentCode: null,
      order: null
    };
    this.processBeneficiaryNotification(
      value, notification, this.certidaoIsensaoIRSNotificationId
    );
  }
  //#endregion certidaoIsensaoIRS


  //#region comprovativoIBAN
  private comprovativoIBANNotification: models.DocumentosObservableVM = DocumentsNeedNotifications.PrestacoesMorte.ComprovativoIBAN;
  private comprovativoIBANNotificationId: BeneficiaryNotification[] = [];

  public comprovativoIBANValidation(bankAccount:string): boolean {
    let result = isNotNullOrUndefinedOrEmpty(bankAccount);
      ;
    return result;
  }
  public changeComprovativoIBANNotification(value: boolean, ownerName: string, ownerNif: number, beneficiaryID: number) {
    const notification: models.DocumentosObservableVM = {
      ...this.comprovativoIBANNotification,
      beneficiaryID: beneficiaryID,
      ownerCode: PersonTypeString.Beneficiary,
      ownerName: ownerName,
      ownerNif: ownerNif,
      ownerTitle: PersonTypeString.Beneficiary,
      ownerParentCode: null,
      order: null
    };
    this.processBeneficiaryNotification(
      value, notification, this.comprovativoIBANNotificationId
    );
  }
  //#endregion comprovativoIBAN

  //#region requerendo
  private requerendoNotification: models.DocumentosObservableVM = DocumentsNeedNotifications.PrestacoesMorte.RequerendoEmNomeHabilitando;
  private requerendoNotificationId: BeneficiaryNotification[] = [];

  public requerendoValidation(isFunerary: boolean): boolean {
    let result = isFunerary?.toString()=='true';
    return result;
  }

  public changeRequerenteHabilitandoNotification(value: boolean, ownerName: string, ownerNif: number, beneficiaryID: number) {
    const notification: models.DocumentosObservableVM = {
      ...this.requerendoNotification,
      beneficiaryID: beneficiaryID,
      ownerCode: PersonTypeString.Beneficiary,
      ownerName: ownerName,
      ownerNif: ownerNif,
      ownerTitle: PersonTypeString.Beneficiary,
      ownerParentCode: null,
      order: null
    };
    this.processBeneficiaryNotification(
      value, notification, this.requerendoNotificationId
    );

  }
  //#endregion requerendo




  //#region PRIVATE METHODS

  private addBeneficiaryNotification(
    beneficiaryName: string,
    nif: number,
    arr: Array<BeneficiaryNotification>, obj:any): number {
    const element = arr.find(el => el.beneficiaryName == beneficiaryName && el.nif == nif);
    if (element != null && element != undefined) {
      return element.noticationId;
    } else {
      const added = {
        noticationId: this.documentsObservableService.pushNotification(obj),
        beneficiaryName: beneficiaryName,
        nif: nif
      }
      arr.push(added);
      return added.noticationId;
    }
    
  }

  private removeBeneficiaryNotification(
    beneficiaryName: string,
    nif: number,
    arr: Array<BeneficiaryNotification>) {
    const beneficiaryNotification = arr
      .find(el => el.beneficiaryName == beneficiaryName && el.nif == nif);
    if (beneficiaryNotification != null && beneficiaryNotification != undefined) {
      this.documentsObservableService.popNotificationById(beneficiaryNotification.noticationId);
      arr = ArrayHelpers.removeItem(arr, beneficiaryNotification);
    } 
  }

  private processBeneficiaryNotification(
 value: boolean,
    notification: models.DocumentosObservableVM,
    notificationId:any) {
    if (value && !this.documentsObservableService.hasDocWithSameNIF(notification)) {
      this.addBeneficiaryNotification(
        notification.ownerName, notification.ownerNif,
        notificationId,
        notification
      );

    } else if (!value) {
      this.removeBeneficiaryNotification(
        notification.ownerName, notification.ownerNif,
        notificationId
      );

    }
  }

  //#endregion PRIVATE METHODS
}


